import React from 'react';
import { TASK_TIME_STATUS_LABELS, normalizeTaskTimeStatus } from '../../utils/taskTimeConstants';

const STATUS_CLASSES = {
  requested: 'bg-amber-100 text-amber-900 dark:bg-amber-900/30 dark:text-amber-100',
  approved: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
  in_progress: 'bg-purple-100 text-purple-800 dark:bg-purple-900/40 dark:text-purple-200',
  completed: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
  denied: 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200',
};

const TaskTimeStatusBadge = ({ status }) => {
  const key = normalizeTaskTimeStatus(status);
  const label = TASK_TIME_STATUS_LABELS[key] || key;
  const classes = STATUS_CLASSES[key] || STATUS_CLASSES.requested;

  return (
    <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${classes}`}>
      {label}
    </span>
  );
};

export default TaskTimeStatusBadge;
